module.exports = __webpack_public_path__ + "img/plus.44ca27b0.svg";